import { signal } from '@preact/signals-react'

export const deviceListSignal = signal([])
export const deviceListLoadingSignal = signal(false)
export const deviceListErrorSignal = signal(null)

export const deviceFormsSignal = signal([])
export const deviceFormsLoadingSignal = signal(false)
export const deviceFormsErrorSignal = signal(null)